import { configureStore } from '@reduxjs/toolkit';
import chatSlice from '@/store/modules/chatSlice.js';
import authSlice from '@/store/modules/authSlice.js';
import globalSlice from './modules/globalSlice.js';
import reportReducer from './modules/reportSlice.js';
const store = configureStore({
  reducer: {
    global: globalSlice,
    chat: chatSlice,
    auth: authSlice,
    report: reportReducer,
  },
});

export default store;
